import React from 'react';
import ReactDOM from 'react-dom/client';
// Symbole (Font Awesome) LOKAL einbinden statt vom fremden Server nachzuladen.
// Vorher lud jede Seite bei cdnjs.cloudflare.com nach - dabei ging die
// IP-Adresse jedes Besuchers an einen Dritten, ohne dessen Zustimmung.
//
// BEWUSST NICHT "all.min.css": das zieht zusaetzlich die Schriftdateien fuer
// Marken-Logos (115 KB) und den Regular-Schnitt (20 KB) nach. Gebraucht wird
// hier ausschliesslich der Solid-Schnitt. Das einzige Marken-Zeichen der Seite
// (WhatsApp) steckt als Grafik in sites/IconWhatsApp.jsx.
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
